import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ProfileImage from '@fiverr-private/profile_image/src/ProfileImage';
import { FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_LOCALE } from '@fiverr-private/fiverr_context/lib/constants';
import Status from './Status';
import OneLiner from './OneLiner';
import Rating from './Rating';
import ContactMe from './ContactMe';

import './style.scss';

const ProfileInfo = (props, context) => {
    const { pathfinderWrapper, requestContext } = context;
    const { locale = DEFAULT_LOCALE } = useContext(FiverrContext);
    const { username } = requestContext.params;
    const {
        isPro,
        oneLiner,
        ratingsCount,
        rating,
        achievement,
        hasProfilePhoto,
        profilePhoto
    } = props;

    const sellerUrl = pathfinderWrapper.pathfinder('short_user', { id: username });
    const profileImageUserProps = {
        username,
        achievement,
        has_profile_photo: hasProfilePhoto,
        profile_photo: profilePhoto,
        is_pro: isPro,
        is_seller: true
    };

    return (
        <div className="profile-info">
            <ProfileImage user={profileImageUserProps} profileImageSize={110} locale={locale}/>
            <div className="user-profile-label">
                <div className="username-line">
                    <a href={sellerUrl} className="seller-link">{username}</a>
                    <Status/>
                </div>
                {(oneLiner || ratingsCount > 0) &&
                    <div className="one-liner-rating-wrapper">
                        {oneLiner && <OneLiner oneLiner={oneLiner}/>}
                        {ratingsCount > 0 && <Rating ratingsCount={ratingsCount} rating={rating}/>}
                    </div>
                }
                <ContactMe/>
            </div>
        </div>
    );
};

ProfileInfo.propTypes = {
    isPro: PropTypes.bool,
    oneLiner: PropTypes.string,
    ratingsCount: PropTypes.number,
    rating: PropTypes.number,
    achievement: PropTypes.number,
    hasProfilePhoto: PropTypes.bool,
    profilePhoto: PropTypes.string
};

ProfileInfo.contextTypes = {
    pathfinderWrapper: PropTypes.object,
    requestContext: PropTypes.object
};

export default ProfileInfo;
